import { writable } from 'svelte/store';

declare interface QuestionnaireHTMLElements {
    slug: string,
    element: HTMLElement
}

declare interface QuestionnaireValidationInterface {
    active: boolean,
    htmlElements: Array<QuestionnaireHTMLElements>
}

const { subscribe, update } = writable<QuestionnaireValidationInterface>({
    active: false,
    htmlElements: [],
});

function activate(): void {
    update((self: QuestionnaireValidationInterface) => Object.assign(self, {
        active: true,
    }));
}

function deactivate(): void {
    update((self: QuestionnaireValidationInterface) => Object.assign(self, {
        active: false,
    }));
}

function addHTMLElement(slug: string, element: HTMLElement): void {
    update((self: QuestionnaireValidationInterface) => {
        if ( !self.htmlElements.some(element => element.slug === slug) ) {
            return Object.assign(self, {
                htmlElements: [ ...self.htmlElements, {
                    slug,
                    element,
                } ],
            });
        }else{
            return self;
        }
    });
}

export const questionnaireValidation = {
    subscribe,
    activate,
    deactivate,
    addHTMLElement
};
